import * as React from "react";
import { Formik, FormikHelpers, Form, Field } from "formik";

import ErrorMessage, { FormContainer, FormContainerWrapper, LoginImage, RootContainer, TextContainer } from "./components";

import noImage from "@assets/img/noimage.jpeg";
import Api from "@services/Api";
import Auth from "@services/Auth";
import { Navigate, useNavigate } from "react-router";
import { RootState, useAppDispatch } from "@services/Redux";
import { useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import LogRocket from "logrocket";
import ReactGA from "react-ga4";
import { fetchUserData } from "@services/Redux/app";
import MetaPixel from "@utils/meta/MetaPixel";

interface LoginFormValues {
  username: string;
  password: string;
}

const LoginScreen: React.FC = () => {
  const companyData = useSelector((state: RootState) => state.company.data);
  const initialValues: LoginFormValues = { username: "", password: "" };
  const [errorMessage, setErrorMessage] = React.useState("");
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  const handleSubmit = async (values: LoginFormValues, actions: FormikHelpers<LoginFormValues>) => {
    try {
      setErrorMessage("");
      actions.setSubmitting(true);
      const { data } = await Api.post(`/user/login`, { ...values, company_code: companyData.code });
      Auth.setAuthData(data.token, data.userName, data.userRole);
      LogRocket.identify(data.userId, {
        name: data.name,
        email: values.username,
      });
      ReactGA.event({ action: "login", category: "Login", label: "Usuário logado" });
      MetaPixel.trackCustom("login", { category: "Login", label: "Usuário logado" });
      dispatch(fetchUserData());
      navigate(searchParams.get("redirect") ?? `/`, { replace: true });
    } catch (error: any) {
      actions.setSubmitting(false);
      if (error?.response?.data?.userMessage === "unauthorized") return setErrorMessage("credenciais inválidas");
      setErrorMessage(error?.response?.data?.userMessage ?? "erro de conexão");
    }
  };

  if (Auth.isAuthenticated()) return <Navigate to="/" />;

  const companyImage = `${companyData?.logo_image?.base_url}/companies/${companyData?.id}/media/thumb_1/${companyData?.logo_image?.key}`;

  return (
    <RootContainer>
      <FormContainerWrapper>
        <LoginImage src={companyImage ?? noImage} width={60} height={60} alt="company-logo" />
        <TextContainer>
          <h2>{companyData.name}</h2>
          <span>Entre com suas credenciais</span>
          <span>
            ou <Link to={`/cadastro`}>cadastre-se</Link>
          </span>
        </TextContainer>
        <FormContainer>
          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({ isSubmitting }) => (
              <Form>
                <div className="mb-4">
                  <span>Email</span>
                  <Field name="username" type="email" className="form-control" placeholder="Digite seu email" required />
                </div>
                <div className="">
                  <span>Senha</span>
                  <Field name="password" type="password" className="form-control" placeholder="Digite sua senha" required />
                </div>
                <ErrorMessage message={errorMessage} />
                <div className="w-100 d-grid mt-4">
                  <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                    entrar
                  </button>
                </div>
                <div className={"mt-3 text-center"}>
                  <Link to={`/esqueci_minha_senha`}>esqueci minha senha</Link>
                </div>
              </Form>
            )}
          </Formik>
        </FormContainer>
      </FormContainerWrapper>
    </RootContainer>
  );
};

export default LoginScreen;
